define('home/views/CommentCardView',[
    'jquery',
    'underscore',
    'backbone',

    'core/mixins/withRichMedia',

    'home/utils/navigationUtils',
    'home/mixins/withAllstarPopover',
    'home/mixins/withSubviews',
    'home/mixins/withTruncate',
    'home/views/common/ActivityCardView',
    'home/views/CommentCardPostActionsView',
    'home/views/PostActivityCollectionView',

    'home/templates/commentCard',
], function (
    $,
    _,
    Backbone,

    withRichMedia,

    navigationUtils,
    withAllstarPopover,
    withSubviews,
    withTruncate,
    ActivityCardView,
    CommentCardPostActionsView,
    PostActivityCollectionView,

    commentCardTemplate
) {
    'use strict';

    var CommentCardView = ActivityCardView.extend({
        className: 'card-wrap is-expandable',

        template: commentCardTemplate,

        templateHelpers: function () {
            var postActivity = this.getPostActivity();

            return {
                expanded: this.expanded,
                discussionRoute: this.model.thread.getDiscussionRoute(),
                postActivity: postActivity.toJSON(),
                relativeTime: postActivity.getRelativeCreatedAt(),
                forumFriendlyUrl: this.model.thread.forum.getFriendlyUrl(),
                threadDescription: this.model.thread.getPlainDescription(),
                image: this.model.thread.getImage(),
            };
        },

        regions: {
            actionsRegion: '[data-role=actions]',
            postsRegion: '[data-role=posts]',
        },

        events: {
            'click': 'handleClick',
            'mouseover': 'beginHover',
            'mouseout': 'endHover',
            'mouseover a': 'endHover',
            'mouseout a': 'beginHover',
            'mouseover [data-role=thread-link]': 'endHover',
            'mouseout [data-role=thread-link]': 'beginHover',
        },

        initialize: function () {
            this.boundRenderPostMedia = _.bind(this.renderPostMedia, this);
        },

        onRender: function () {
            this.activateRegion(this.actionsRegion, this.createDefaultActionsView);

            // Comments are rendered by the postCollectionView in the expanded
            // version of this view. Rich media is handled by the item views.
            if (this.expanded)
                this.activateRegion(this.postsRegion, this.createPostCollectionView);
            // Rendering rich media must wait for truncation to complete because
            // of an incompatibility between IFrameRichMedia and the trunk8
            // plugin. The IFrameRichMediaView shows loading spinners that are
            // removed when the iframe is loaded, but trunk8 removes the iframe
            // from the DOM and reinserts it, losing the load event handler
            // that removes that loading spinners.
            // If this view was previously shown, truncation (which happens in
            // onDomRefresh) will have completed before onRender is called.
            else if (this._isShown)
                this.boundRenderPostMedia();
            // If this render is happening before the view is shown, truncation
            // will occur once the view is shown. Wait until it completes
            // before rendering rich media.
            else
                this.listenToOnce(this, 'truncate:complete', this.boundRenderPostMedia);
        },

        renderPostMedia: function () {
            var post = this.getPostActivity().object;
            this.renderRichMedia(post.get('media'));
        },

        // The backend does not group activities for this feed,
        // so there should only be 1 activity to display
        getPostActivity: function () {
            return this.model.activities[0];
        },

        createDefaultActionsView: function () {
            return new CommentCardPostActionsView({
                model: this.getPostActivity().object,
            });
        },

        createPostCollectionView: function () {
            return new PostActivityCollectionView({
                el: this.postsRegion.el,
                collection: new Backbone.Collection(this.model.activities),
                collapsePosts: false,
            });
        },

        handleClick: function (evt) {
            if ($(evt.target).closest('[data-role=thread-link]').length) {
                navigationUtils.navigate(this.model.thread.getDiscussionRoute(), { trigger: true });
                return false;
            }

            this.toggleExpanded(evt);
        },

        toggleExpanded: function (evt) {
            // Don't toggle expanded state if user clicked on a link or in a form.
            if ($(evt.target).closest('a, form', this.$el).length)
                return;

            this.expanded = !this.expanded;
            this.render();

            // After render has completed, check if the card is still hovered
            _.delay(_.bind(this.checkHovered, this));
        },

        checkHovered: function () {
            // After card has (un)expanded, checks if the card is still hovered.
            // If the cursor is over this card but not any of the links in the card,
            // show the hover state.
            var cardIsHovered = this.$el.is(':hover') &&
                !this.$el.find('a:hover').length &&
                !this.$el.find('[data-role=thread-link]:hover').length;

            this.$el.toggleClass('is-hovered', cardIsHovered);
        },

        beginHover: function (evt) {
            // Don't show the hover state when user is hovering over a link
            // ([data-role=thread-link] acts as a link so treat it as such)
            var $target = $(evt.target);
            if (!$target.closest('a', this.$el).length &&
                !$target.closest('[data-role=thread-link]', this.$el).length)

                this.$el.addClass('is-hovered');
        },

        endHover: function () {
            this.$el.removeClass('is-hovered');
        },
    });

    withAllstarPopover.call(CommentCardView.prototype);
    withTruncate.call(CommentCardView.prototype);
    withSubviews.call(CommentCardView.prototype);
    withRichMedia.call(CommentCardView.prototype);

    return CommentCardView;
});

